import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { AuthUser } from '../lib/types';
import { useAuth } from './AuthProvider';

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {complete} = useAuth();
  const processed = useRef(false);
  const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
  const state = new URLSearchParams(location.search).get('auth_state');
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const exchange = async () => {
      try {
        if (!sessionId || !state) throw new Error('This sign-in link is incomplete. Please start Google sign-in again.');
        const user = await api<AuthUser>('/auth/session', 'POST', {session_id: sessionId, state});
        complete(user);
        // Reactive navigation removes BOTH temporary credentials and OAuth state.
        navigate('/', {replace: true});
      } catch (error: any) {
        navigate('/auth/error', {replace: true, state: {message: error.message}});
      }
    };
    void exchange();
  }, [sessionId, state, complete, navigate]);
  return null;
};